import React from 'react'
import { useSelector } from 'react-redux'

import { useCampaignFiles } from '@/app/module/campaigns/component/campaign-files-provider'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUpdateFile = (messageId: string) => {
  const dispatch = useAppDispatch()
  const { updateFile: storeFile } = useCampaignFiles()
  const orgId = useSelector(selectOrgId)
  const [update, response] = esApi.endpoints.updateFile.useMutation()

  const updateFile = React.useCallback(
    async (filename: string, transcript: string) => {
      try {
        await update({
          filename,
          orgId: orgId.toString(),
          body: {
            transcript,
          },
        }).unwrap()
        storeFile({
          id: messageId,
          filename,
          transcription: transcript,
        })
        return true
      } catch {
        dispatch(
          createNotification({
            'update-file': {
              type: 'error',
              disableAutoHide: true,
              message: 'Failed to update file transcript, please try again later.',
            },
          }),
        )
        return false
      }
    },
    [messageId, orgId, dispatch, storeFile, update],
  )

  return [updateFile, response] as const
}
